<template>
  <a
    :href="url"
    class="photo"
  >
    <div class="photo__inner" :style="{ backgroundImage: `url(${ src })` }"/>
    <plus-icon class="photo__plus"/>
  </a>
</template>

<script>
import PlusIcon from '@/components/PlusIcon'

export default {
  components: {
    PlusIcon
  },
  props: {
    src: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .photo {
    @include reset-link;
    @include vertical-space((top: 2, bottom: 2));
    @include cover-background;

    display: block;
    overflow: hidden;
    position: relative;
    height: 14 * $vertical-space;

    &__plus {
      @include center-self(absolute);
      height: 100px;
      width: 100px;
      opacity: 0;
      transition: opacity .3s;
    }

    &:hover &__plus {
      opacity: 1;
    }

    &__inner {
      @include cover-background;
      width: 100%;
      height: 100%;

      transition: transform .4s;
    }

    &:hover &__inner {
      transform: scale(1.05);
    }

    @include media-up(md) {
      height: 21 * $vertical-space;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Photo.vue